import React, { ReactNode } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";

import {
  FlatButton,
  FlatButtonProperties,
} from "src/framework/components/buttons";

import { observer } from "mobx-react-lite";

import { notifierStore } from "src/framework/store";

import "./style.css";

const button: FlatButtonProperties = {
  text: "Ok",
  color: "primary",
  variant: "contained",
  onClick: () => notifierStore.getOnClose(),
};

const Notifier = observer(() => {
  const contentNotifier = (content: any): ReactNode => {
    if (typeof content === "string") {
      return <>{content}</>
    } else {
      if (Array.isArray(content)) {
        return <>{content.map(rec => <>{rec}<br /></>)}</>
      } else {
        return content;
      }
    }
  }

  return (
    <div>
      <Dialog open={notifierStore.getOpen()} style={{ minWidth: "300px" }}>
        <div
          onMouseEnter={() => notifierStore.onMouseEnter()}
          id="notifier-container"
        >
          {notifierStore.getShowProgress() ? (
            <LinearProgress
              id="timeout-progress"
              variant="determinate"
              value={notifierStore.getPercent()}
            />
          ) : (
            ""
          )}
          <DialogTitle id="simple-dialog-title">
            {notifierStore.getTitle()}
          </DialogTitle>
          <DialogContent style={{ minWidth: "300px" }}>
            <DialogContentText id="alert-dialog-description">
              {contentNotifier(notifierStore.getContent())}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <FlatButton {...button} />
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
});

export { Notifier };
